@if (loading) {
  <div class="text-center pt-5">
    <app-loading-spinner></app-loading-spinner>
  </div>
}

@if (examinee) {
  <ngx-simplebar class="mx-n3 pt-4 px-4 file-manager-content-scroll">
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="bg-success-subtle">
            <div class="card-body pb-0 px-4">
              <div class="row justify-content-center align-items-center text-center">
                <div class="col-1">
                  <button role="none" (click)="goBack()" class="btn btn-sm btn-secondary mb-3"><i title="Back to examines" class="ri-arrow-left-line me-1"></i>Go Back</button>
                </div>
                <div class="col">
                  <div class="row justify-content-center align-items-center mb-2">
                    <div>
                      <h1 class="fw-bold">Examinee Report</h1>
                      <div class="justify-content-center align-items-center hstack gap-3 flex-wrap">
                        <div><span class="fw-bold text-decoration-underline">Invitation Date</span>: <span class="fw-medium">{{ examinee.createdAt | date: 'medium' }}</span></div>
                        <div class="vr"></div>
                        <div><span class="fw-bold text-decoration-underline">Answered Date</span>: <span class="fw-medium">{{ examinee.answered_at | date: 'medium' }}</span></div>
                        <!-- <div class="vr"></div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row border-bottom border-soft-dark m-3">
            <div class="col-12 col-md-4 border-end border-soft-dark">
              <h3 class="mb-3">Person Details</h3>
              <div class="table-responsive">
                <table class="table table-borderless mb-0">
                  <tbody>
                    <tr>
                      <th class="ps-0" scope="row">Full Name:</th>
                      <td class="text-muted">{{ examinee.person?.first_name }} {{ examinee.person?.last_name }}</td>
                    </tr>
                    @if (examinee.person?.phone_country_code && examinee.person?.phone) {
                      <tr>
                        <th class="ps-0" scope="row">Mobile:</th>
                        <td class="text-muted">+({{ examinee.person?.phone_country_code }}) {{ examinee.person?.phone }}</td>
                      </tr>
                    }
                    <tr>
                      <th class="ps-0" scope="row">E-mail:</th>
                      <td class="text-muted">{{ examinee.person?.email }}</td>
                    </tr>
                    @if (examinee.person?.city && examinee.person?.country) {
                      <tr>
                        <th class="ps-0" scope="row">Location:</th>
                        <td class="text-muted">{{ examinee.person?.city }}, {{ examinee.person?.country }}</td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
            <div class="col-12 col-md-4 border-end border-soft-dark">
              <h3 class="mb-3">Questionnaire Details</h3>
              <div class="table-responsive">
                <table class="table table-borderless mb-0">
                  <tbody>
                    <tr>
                      <th class="ps-0" scope="row">Questionnaire name:</th>
                      <td class="text-muted">{{ questionnaire.name }}</td>
                    </tr>
                    <tr>
                      <th class="ps-0" scope="row">Total chapters:</th>
                      <td class="text-muted">{{ questionnaire.chapters.length }}</td>
                    </tr>
                    <tr>
                      <th class="ps-0" scope="row">Total questions:</th>
                      <td class="text-muted">{{ getTotalQuestionCount() }}</td>
                    </tr>
                    <tr>
                      <th class="ps-0" scope="row">Language:</th>
                      <td class="text-muted">{{ getLanguage(questionnaire.lang_code) | titlecase }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="col-12 col-md-4 text-center">
              <h3 class="card-title">Final Score</h3>
              <circle-progress
                [percent]="final_score"
                [radius]="80"
                [outerStrokeWidth]="6"
                [showInnerStroke]="false"
                [outerStrokeColor]="final_score_color"
                [animation]="true"
                [animationDuration]="500"
                [showSubtitle]=false
                [titleColor]="final_score_color"
                [unitsColor]="final_score_color">
              </circle-progress>
            </div>
          </div>
          <div class="row border-bottom border-soft-dark mx-3">
            <div class="col-lg-12">
              <div class="card-body">
                <app-questionnaire-chapters [viewMode]="true" [chapters]="questionnaire.chapters" [report]="true"></app-questionnaire-chapters>
              </div>
            </div>
          </div>
          <div class="row border-bottom border-soft-dark m-3">
            <div #containerRef class="col-12 mb-3">
              <h3 class="mb-3">Stress Statistics</h3>
              <ngx-charts-line-chart #chart1 class="dark"
                [scheme]="colorSchemeLine" [results]="stress_chart_data"
                [gradient]="gradient" [xAxis]="showXAxis" [yAxis]="showYAxis"
                [legend]="showLegend" [showXAxisLabel]="showXAxisLabel"
                [showYAxisLabel]="showYAxisLabel" [xAxisLabel]="xAxisLabel"
                [yAxisLabel]="yAxisLabel" [autoScale]="autoScale" [animations]="false" [showGridLines]="showGridLines" [roundDomains]="true">
              </ngx-charts-line-chart>
            </div>
          </div>
          <div class="row m-3">
            <div #containerRef class="col-12">
              <h3 class="mb-3">Organizational Threshold</h3>
              <ngx-charts-bar-vertical-2d #chart2 [ngClass]="theme ? theme : ''"
                [scheme]="colorSchemeTheme" [results]="thresh_chart_data"
                [gradient]="gradient" [xAxis]="showXAxis" [yAxis]="showYAxis"
                [legend]="showLegend" [showXAxisLabel]="showXAxisLabel"
                [showYAxisLabel]="showYAxisLabel" [xAxisLabel]="xAxisLabel"
                [yAxisLabel]="yAxisLabel" [autoScale]="autoScale" [animations]="false" [showGridLines]="showGridLines" [roundDomains]="true">
              </ngx-charts-bar-vertical-2d>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ngx-simplebar>
}